module.exports = __webpack_public_path__ + "static/media/javascript-lab2-html.e6486dbf.JPG";